import { DateInput, Input, Select } from 'components'
import moment from 'moment'
import { SearchingSectionProps } from 'pages/Purchase/Register/types'
import { useEffect } from 'react';
import { useListPO } from '../hooks';
import { SelectOptionType } from 'types';

export const SearchingSections = ({ selected, setSelected }: SearchingSectionProps) => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  const dateTo = new Date(year, month, 1);
  const dateEnd = new Date(year, month + 1, 0);

  const { dataPO, isLoadingPO, refetchPO } = useListPO()

  const selectApproval: SelectOptionType[] = [
    { value: "1", label: "PENDING" },
    { value: "2", label: "REVISI" },
    { value: "3", label: "REJECT" },
    { value: "4", label: "APPROVE" },
  ]
  const selectStatus: SelectOptionType[] = [
    { value: "1", label: "OPEN" },
    { value: "2", label: "CLOSE" },
    { value: "3", label: "CREDIT" },
  ]
  const sortedSelectDummy = dataPO.sort((a, b) => parseInt(b.value) - parseInt(a.value));
  const sortedSelectApproval = selectApproval.sort((a, b) => parseInt(b.value) - parseInt(a.value));
  const sortedSelectStatus = selectStatus.sort((a, b) => parseInt(b.value) - parseInt(a.value));
  const allOption = { value: "", label: "All" };

  useEffect(() => {
    if(selected?.date_from === "") { setSelected({ ...selected, date_from: moment(dateTo).format("YYYY-MM-DD")}) }
    if(selected?.date_end === "") { setSelected({ ...selected, date_end: moment(dateEnd).format("YYYY-MM-DD")}) }

    // eslint-disable-next-line
  }, [selected])

  useEffect(() => {
    if(selected?.date_from && selected?.date_end) { refetchPO({ DateFrom: selected?.date_from, DateEnd: selected?.date_end}) }

    // eslint-disable-next-line
  }, [selected])

  return (
    <section>
        <div className="lg:flex overflow-x-auto">
            <div className='flex items-center w-[284px] lg:w-[240px]'>
                <div className="label-text pb-1 font-bold pe-2 lg:w-[145px] w-[350px] uppercase">Date From</div>
                <DateInput
                    className="!w-[150px]"
                    placeholderText="Date From"
                    onChange={(date) => setSelected({ ...selected, date_from: moment(date).format("YYYY-MM-DD")})}
                    selected={ selected?.date_from ? moment(selected?.date_from).toDate() : null }
                />
            </div>
            <div className='flex items-center w-[284px] lg:w-[230px] mt-2 lg:mt-0'>
                <div className="lg:mt-0 lg:px-2 pb-1 label-text font-bold lg:w-[110px] !w-[550px] uppercase">Date To</div>
                <DateInput
                    className="!w-[150px]"
                    placeholderText="Date To"
                    onChange={(date) => setSelected({ ...selected, date_end: moment(date).format("YYYY-MM-DD")})}
                    selected={ selected?.date_end ? moment(selected?.date_end).toDate() : null }
                />
            </div>
            <div className='flex items-center ml-1 mt-2 lg:mt-0'>
                <div className="lg:mt-0 lg:px-2 pb-1 label-text font-bold w-[142px] lg:w-full">PO</div>
                <Select
                    className="w-[150px]"
                    placeholder="Select Location"
                    isLoading={isLoadingPO}
                    value={selected?.purchase_order_id !== "" ? [allOption, ...sortedSelectDummy].find((item) => item.value?.toString() === selected?.purchase_order_id?.toString()) : allOption}
                    options={[allOption, ...dataPO]}
                    onChange={(e) => setSelected({ ...selected, purchase_order_id: e?.value! })}
                />
            </div>
            <div className='flex items-center ml-1 mt-2 lg:mt-0'>
                <div className="lg:mt-0 lg:px-2 pb-1 label-text font-bold w-[142px] lg:w-full">APPROVAL</div>
                <Select
                    className="w-[150px]"
                    placeholder="Select Location"
                    value={selected?.approve_status !== "" ? [allOption, ...sortedSelectApproval].find((item) => item.value?.toString() === selected?.approve_status?.toString()) : allOption}
                    options={[allOption, ...selectApproval]}
                    onChange={(e) => setSelected({ ...selected, approve_status: e?.value! })}
                />
            </div>
            <div className='flex items-center ml-1 mt-2 lg:mt-0'>
                <div className="lg:mt-0 lg:px-2 pb-1 label-text font-bold w-[142px] lg:w-full">STATUS</div>
                <Select
                    className="w-[150px]"
                    placeholder="Select Location"
                    value={selected?.bill_status !== "" ? [allOption, ...sortedSelectStatus].find((item) => item.value?.toString() === selected?.bill_status?.toString()) : allOption}
                    options={[allOption, ...selectStatus]}
                    onChange={(e) => setSelected({ ...selected, bill_status: e?.value! })}
                />
            </div>
        </div>
        <Input 
            inputClass='w-[300px] mt-5' 
            placeholder='Search data...'  
            value={selected?.search}
            onChange={(e) => setSelected({ ...selected, search: e?.target?.value })}
        />
    </section>
  )
}